<template>
  <div class="app">
    <div class="map" id="map"></div>
    <div id="section" :style="{ height: height, width: width }" v-if="showsection">
      <div id="header"><span id="title">条件查询</span><img :src="close" alt="" @click="setsearch" /></div>
      <p style="margin-bottom: -10px">
        <a-select v-model="querytype" @change="changevalue" style="width: 220px; margin-top: -20px">
          <a-select-option value="1">任务</a-select-option>
          <a-select-option value="2">事件</a-select-option>
          <a-select-option value="3">工单</a-select-option>
        </a-select>
      </p>
      <p style="color: #fff; margin-bottom: -7px">编号查询</p>
      <a-input v-model="eventNo" placeholder="输入编号查询"
        style="background: rgba(0, 32, 54, 0.75); width: 220px; margin-left: 9px; color: #fff" />
      <p v-if="querytype == 1" style="color: #fff; margin-bottom: -7px">任务类型</p>
      <p v-else-if="querytype == 2" style="color: #fff; margin-bottom: -7px">事件类型</p>
      <p v-else-if="querytype == 3" style="color: #fff; margin-bottom: -7px">工单类型</p>
      <p v-if="querytype == 1" style="margin-top: -10px">
        <a-select label-in-value v-model="type" @change="gettype" style="width: 220px; margin-top: -20px">
          <a-select-option v-for="(item, index) in dictlist" :key="index" :value="item" :label="item">
            {{ item }}
          </a-select-option>
        </a-select>
      </p>
      <p v-else-if="querytype == 2" style="margin-top: -10px">
        <a-select label-in-value v-model="eventtype" @change="geteventtype" style="width: 220px; margin-top: -20px">
          <a-select-option value="压力事件" label="压力事件"> 压力事件 </a-select-option>
          <a-select-option value="漏损事件" label="漏损事件"> 漏损事件 </a-select-option>
          <a-select-option value="管网事件" label="管网事件"> 管网事件 </a-select-option>
          <a-select-option value="抄表推送" label="抄表推送"> 抄表推送 </a-select-option>
        </a-select>
      </p>
      <p v-else-if="querytype == 3" style="margin-top: -10px">
        <a-select label-in-value v-model="ordertype" @change="getordertype" style="width: 220px; margin-top: -20px">
          <a-select-option value="自报单" label="自报单"> 自报单 </a-select-option>
          <a-select-option value="热线工单" label="热线工单"> 热线工单 </a-select-option>
          <a-select-option value="养护工单" label="养护工单"> 养护工单 </a-select-option>
          <a-select-option value="巡检工单" label="巡检工单"> 巡检工单 </a-select-option>
          <a-select-option value="抄表推送" label="抄表推送"> 抄表推送 </a-select-option>
        </a-select>
      </p>
      <p v-if="querytype == 1 || querytype == 3" style="color: #fff; margin-top: -25px; margin-bottom: -4px">负责人</p>
      <a-input v-model="pepole" v-if="querytype == 1 || querytype == 3" @change="handleChange" placeholder="输入负责人"
        style="background: rgba(0, 32, 54, 0.75); width: 220px; margin-left: 9px; color: #fff" />
      <p v-if="querytype == 2" style="color: #fff; margin-top: -25px; margin-bottom: -4px">上报人</p>
      <a-input v-model="reportPerson" v-if="querytype == 2" @change="handleChang" placeholder="输入上报人"
        style="background: rgba(0, 32, 54, 0.75); width: 220px; margin-left: 9px; color: #fff" />
      <p style="color: #fff; margin-bottom: 1px" v-if="querytype == 1 || querytype == 2">片区</p>
      <a-tree-select v-if="querytype == 1 || querytype == 2" v-model="addOrUpdateForm.zoneId"
        style="width: 220px; margin-left: 10px; margin-top: -20px"
        :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
        :replace-fields="{ title: 'zoneName', key: 'id', value: 'id', selectable: 'selectable' }" :tree-data="treeData"
        placeholder="选择片区" tree-default-expand-all>
      </a-tree-select>
      <p style="color: #fff; margin-bottom: 3px">日期</p>
      <a-date-picker style="width: 220px; margin-left: 10px; margin-top: -20px" v-model="addOrUpdateForm.createTime"
        @change="onChange" />
      <div id="button">
        <a-button type="primary" style="margin-right: 30px; margin-top: 20px" @click="searchinfo"> 查询 </a-button>
        <a-button style="margin-top: 20px" @click="resetList">重置</a-button>
      </div>
      <a-table :columns="columns" :data-source="pathlist" :pagination="pagination" @change="pageChange">
        <span slot="taskType" slot-scope="text, record" @click="handleInputChange(record)">
          {{ text }}
        </span>
      </a-table>
    </div>
    <div class="Track" v-if="isshowPathlist">
      <div id="closeitem">
        <span>轨迹列表</span>
        <!-- <img :src="close" alt="" id="close" /> -->
      </div>
      <a-table :columns="columns" :data-source="pathList" :pagination="pagination" @change="pageChange">
        <span slot="taskType" slot-scope="text, record" @click="showPath(record)">
          {{ text }}
        </span>
      </a-table>
    </div>
    <div id="popup" v-if="showinfo">
      <div id="closeitem" @click="closepopup">
        <span>详情</span>
        <img :src="close" alt="" id="close" />
      </div>
      <ul>
        <li>
          巡检员:<span>{{ name }}</span>
        </li>
        <li>
          开始时间:<span>{{ starttime }}</span>
        </li>
        <li>
          结束时间:<span>{{ endtime }}</span>
        </li>
        <li>
          巡检总距离:<span>{{ round }}</span>
        </li>
        <li>
          巡检总时长:<span>{{ counttime }}</span>
        </li>
      </ul>
    </div>
    <div id="popuplist" v-if="showpopup">
      <div id="closeitem" @click="closepopup">
        <span>详情</span>
        <img :src="close" alt="" id="close" />
      </div>
      <ul>
        <li>
          <span v-if="pointType == 'events'">事件类型 : {{ currentInfo.eventType }}</span>
          <span v-else>工单类型 : {{ currentInfo.workOrderType }}</span>
        </li>
        <li>
          <span v-if="pointType == 'events'">事件编号 : {{ currentInfo.eventNo }}</span>
          <span v-else>工单编号 : {{ currentInfo.workNo }}</span>
        </li>
        <li>
          <span>创建时间 : {{ currentInfo.createTime }}</span>
        </li>
        <li>
          <span v-if="pointType == 'events'">上报时间 : {{ currentInfo.reportTime }}</span>
        </li>
        <li>
          <span v-if="pointType == 'events'">上报人 : {{ currentInfo.reportPerson }}</span>
          <span v-else>负责人 : {{ currentInfo.principalName }}</span>
        </li>
        <li>
          <span>联系电话 : {{ currentInfo.phone }}</span>
        </li>
        <li>
          <span v-if="pointType == 'events'" id="desript">事件描述 : {{ currentInfo.eventDescription }}</span>
          <span v-else>工单来源 : {{ currentInfo.workOrderSource }}</span>
        </li>
      </ul>
    </div>
    <div id="tuli" v-if="isshow">
      <div id="Legend">图例</div>
      <div @click="operation('events')">
        <img :src="shijian" alt="" /><span>事件 : {{ eventsnum }}
          <span><img class="righticon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAABkvfSiAAABjUlEQVRIDb3WwSsEURzA8e+iJAftRXJaF+WEf0C7B0WJEkoOlFLKX8AWN2e50m4RJe1VisNeHBQlkpOEsnLQotjDGu+1bW9mzaz37My8mpnfm5n3+8x7v2kaCLMlrZXwOIktWlYkFFFi3yxLK3jQhgUPVmDBgi5YcKAHFgxYBfMf/APzF9TA/AM1MX9AA6x20BCrDfwHJsE6uTNumlid+HAeTMPhjBIaVKgZaWIyWzIOve3Qs65ym4EGWLxDgAkYTEPuQ4H6S2qAtTbDzgSsZuH4VmEyqnd2PXouWGoUutsge+ccI+uWmYLXT5jNgOW8rAG6YDLHQx7SY3DzAtdiK7elOAx3QX8K3grls+pYfYYemBz+9F6axdoQ7F2K+Av6YrApZj6+Cxc5hdgjsQAerQpmH7E/CbEojGzD6TykzsTLcmS/wxm7g5qYTNXSCOcLEG2Cq2dIbECxsnA28/eSGmAyT6EIJ/cw0ClqtwV5l7rZvIqfKEPMnkg3VksaAiYfqgSGhAnvMUKImADnfgAPvJ/oBeyxIAAAAABJRU5ErkJggg=="
              alt="" v-if="eventactive" /></span></span>
      </div>
      <div @click="operation('order')">
        <img :src="gongdan" alt="" /><span>工单 : {{ ordernum }}
          <span><img class="righticon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAABkvfSiAAABjUlEQVRIDb3WwSsEURzA8e+iJAftRXJaF+WEf0C7B0WJEkoOlFLKX8AWN2e50m4RJe1VisNeHBQlkpOEsnLQotjDGu+1bW9mzaz37My8mpnfm5n3+8x7v2kaCLMlrZXwOIktWlYkFFFi3yxLK3jQhgUPVmDBgi5YcKAHFgxYBfMf/APzF9TA/AM1MX9AA6x20BCrDfwHJsE6uTNumlid+HAeTMPhjBIaVKgZaWIyWzIOve3Qs65ym4EGWLxDgAkYTEPuQ4H6S2qAtTbDzgSsZuH4VmEyqnd2PXouWGoUutsge+ccI+uWmYLXT5jNgOW8rAG6YDLHQx7SY3DzAtdiK7elOAx3QX8K3grls+pYfYYemBz+9F6axdoQ7F2K+Av6YrApZj6+Cxc5hdgjsQAerQpmH7E/CbEojGzD6TykzsTLcmS/wxm7g5qYTNXSCOcLEG2Cq2dIbECxsnA28/eSGmAyT6EIJ/cw0ClqtwV5l7rZvIqfKEPMnkg3VksaAiYfqgSGhAnvMUKImADnfgAPvJ/oBeyxIAAAAABJRU5ErkJggg=="
              alt="" v-if="orderactive" /></span></span>
      </div>
      <div @click="operation('user')">
        <img :src="online" alt="" /><span>在线 : {{ onlinenum }}
          <span><img class="righticon"
              src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAHKADAAQAAAABAAAAHAAAAABkvfSiAAABjUlEQVRIDb3WwSsEURzA8e+iJAftRXJaF+WEf0C7B0WJEkoOlFLKX8AWN2e50m4RJe1VisNeHBQlkpOEsnLQotjDGu+1bW9mzaz37My8mpnfm5n3+8x7v2kaCLMlrZXwOIktWlYkFFFi3yxLK3jQhgUPVmDBgi5YcKAHFgxYBfMf/APzF9TA/AM1MX9AA6x20BCrDfwHJsE6uTNumlid+HAeTMPhjBIaVKgZaWIyWzIOve3Qs65ym4EGWLxDgAkYTEPuQ4H6S2qAtTbDzgSsZuH4VmEyqnd2PXouWGoUutsge+ccI+uWmYLXT5jNgOW8rAG6YDLHQx7SY3DzAtdiK7elOAx3QX8K3grls+pYfYYemBz+9F6axdoQ7F2K+Av6YrApZj6+Cxc5hdgjsQAerQpmH7E/CbEojGzD6TykzsTLcmS/wxm7g5qYTNXSCOcLEG2Cq2dIbECxsnA28/eSGmAyT6EIJ/cw0ClqtwV5l7rZvIqfKEPMnkg3VksaAiYfqgSGhAnvMUKImADnfgAPvJ/oBeyxIAAAAABJRU5ErkJggg=="
              alt="" v-if="useractive" /></span></span>
      </div>
    </div>
    <div id="control">
      <img :src="search" alt="" @click="setsearch" />
      <span @click="setsearch">条件查询</span>
      <img :src="tools" alt="" @click="showlayer" />
      <span @click="showlayer">图例</span>
      <img :src="clear" alt="" v-if="isshowpath" @click="removeLayer('轨迹')" />
      <img :src="path" alt="" v-else @click="getCurrentpath" />
      <span @click="removeLayer('轨迹')" v-if="isshowpath">清除轨迹</span>
      <span @click="getCurrentpath" v-else>轨迹</span>
      <span style="float: right; margin-right: 10px">
        <img :src="online" alt="" />
        在线人数 : {{ onlinenum }}
      </span>
    </div>
  </div>
</template>

<script>
// 导入模块
// import mixinViewModule from '@/mixin/commonModel'
import 'ol/ol.css'
import Map from 'ol/Map'
import TileLayer from 'ol/layer/Tile'
import View from 'ol/View'
import XYZ from 'ol/source/XYZ'
import * as turf from '@turf/turf'
import { getVectorContext } from 'ol/render'
import { defaults as defaultControls } from 'ol/control'
// import { get as getProjection } from 'ol/proj'
import Draw from 'ol/interaction/Draw'
import { DragBox, Select } from 'ol/interaction'
import VectorSource from 'ol/source/Vector'
import VectorLayer from 'ol/layer/Vector'
import Feature from 'ol/Feature'
import Stroke from 'ol/style/Stroke'
import Fill from 'ol/style/Fill'
import Point from 'ol/geom/Point'
import LineString from 'ol/geom/LineString'
import Style from 'ol/style/Style'
import Icon from 'ol/style/Icon'
import Text from 'ol/style/Text'
import Circle from 'ol/style/Circle'
import Scanler from 'ol/control/ScaleLine'
import { searchPlace } from '@/api/manage'
import * as olProj from 'ol/proj'
// import streetData from '/test.json'
import GeoJSON from 'ol/format/GeoJSON'
import start from '@/assets/myImg/1/start.png'
import end from '@/assets/myImg/1/end.png'
import shijian from '@/assets/myImg/1/shijian.png'
import gongdan from '@/assets/myImg/1/gongdan.png'
import online from '@/assets/myImg/1/online.png'
import search from '@/assets/myImg/1/search.png'
import close from '@/assets/myImg/1/icon-close.png'
import draw from '@/assets/myImg/1/icon-框选.png'
var lineMarker
var position
var lineLayer
var styles
export default {
  // mixins: [mixinViewModule],
  name: 'Map',
  // 数据
  data () {
    return {
      queryUrl: 'pipe-network/inspection_tasks/page', // 列表请求数据接口
      querytype: '',
      eventquery: {
        sysType: '巡检',
        isMap: true
      },
      orderquery: {
        sysType: '巡检',
        isMap: true,
        isApp: true
      },
      eventactive: true,
      useractive: true,
      orderactive: true,
      onlinenum: 0,
      ordernum: 0,
      eventsnum: 0,
      onlinelist: [],
      eventslist: [],
      orderlist: [],
      isshowonline: false,
      isshoworders: false,
      isshowevents: false,
      showpopup: false,
      pointType: '',
      currentInfo: [],
      map: null,
      mapcenter: [],
      pathlists: [],
      tools: '/icon/layer.png',
      path: '/icon/path.png',
      clear: '/icon/clear.png',
      shijian: shijian,
      gongdan: gongdan,
      online: online,
      search: search,
      close: close,
      isshow: false,
      isshowpath: false,
      isshowPathlist: false,
      isshowpathlist: false,
      showsection: false,
      pathlist: [],
      pathList: [],
      dictlist: [],
      userlist: [],
      Reassign: true,
      height: '100%',
      width: '240px',
      treeData: [],
      date: '',
      type: '',
      eventtype: '',
      eventNo: '',
      ordertype: '',
      pepole: '',
      reportPerson: '',
      geoMarker: null,
      animating: true,
      startTime: null,
      speed: 1,
      distance: 0,
      positions: null,
      currentPoint: null,
      currentCount: null,
      traversed: null,
      addOrUpdateForm: {
        place: '',
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        taskNumber: '',
        status: '',
        createTime: ''
      },
      showinfo: false,
      name: '',
      starttime: '',
      endtime: '',
      round: '',
      counttime: '',
      pagination: {
        current: 1,
        pageSize: 2,
        total: 0,
        simple: true,
        size: 'small',
        showSizeChanger: false,
        showQuickJumper: false
      },
      columns: [
        {
          title: '轨迹列表',
          dataIndex: 'taskType',
          align: 'center',
          key: 'taskId',
          scopedSlots: { customRender: 'taskType' }
        }
      ]
    }
  },
  watch: {
    value (value) {
      console.log(value)
    }
  },
  computed: {
    title () {
      return `${this.$store.getters.userInfo.tenant.shortName}智慧管理平台`
    },
    currentUser () {
      return this.$store.getters.userInfo
    },
    token () {
      return this.$store.getters.token
    }
  },
  created () {
    this.settype()
    this.getUserList()
    this.gettreeData()
  },
  mounted () {
    this.initMap()
  },
  methods: {
    resetList () {
      this.addOrUpdateForm = {
        place: '',
        taskType: '',
        startTime: '',
        zoneId: '',
        description: '',
        address: '',
        assistPersons: [],
        principal: '',
        taskNumber: '',
        status: '',
        createTime: ''
      }
      this.eventtype = ''
      this.eventNo = ''
      this.type = ''
      this.ordertype = ''
      this.date = ''
      this.pepole = ''
      this.querytype = ''
      this.reportPerson = ''
      this.pathlist = []
      this.removeAllDraw()
    },
    showPath (path) {
      const point = path.geoJson.coordinates
      console.log(JSON.stringify(path))
      const Path = {
        point: point,
        start: path.startTime,
        end: path.endTime,
        name: path.name
      }
      this.removeLayer('轨迹')
      this.name = path.name
      this.starttime = path.startTime
      this.endtime = path.endTime
      this.round = path.distance
      this.counttime = path.duration
      this.drawLineString(Path)
    },
    getCurrentpath () {
      this.$http.get('/pipe-network/task_travel_trajectory/travel/login/info')
        .then((resolve) => {
          console.log(JSON.stringify(resolve))
          const path = []
          if (resolve.data.length > 1) {
            if (this.isshowPathlist) {
              this.isshowPathlist = false
              this.pagination.pageSize = 2
              this.pagination.total = 0
            } else {
              resolve.data.map(item => {
                this.pathList.push({
                  createUserId: item.createUserId,
                  taskType: item.name,
                  taskId: item.id,
                  createTime: item.createTime,
                  name: item.name,
                  startTime: item.startTime,
                  endTime: item.endTime,
                  distance: item.distance + ' 千米',
                  duration: item.duration,
                  geoJson: JSON.parse(item.geoJson)
                })
              })
              this.pagination.pageSize = 5
              this.pagination.total = resolve.data.length
              this.isshow = false
              this.isshowPathlist = true
            }
          } else {
            this.name = resolve.data[0].name
            this.starttime = resolve.data[0].startTime
            this.endtime = resolve.data[0].endTime
            this.round = resolve.data[0].distance + '千米'
            this.counttime = resolve.data[0].duration
            var point = JSON.parse(resolve.data[0].geoJson).coordinates
            path.push({
              point: point,
              start: resolve.data[0].startTime,
              end: resolve.data[0].endTime,
              name: resolve.data[0].name
            })
            this.drawLineString(path[0])
          }
        })
    },
    getUserList () {
      this.$http.get('/manager/users/list').then(({ data }) => {
        const list = []
        data.map((item) => {
          list.push({
            title: item.realName,
            key: item.id
          })
        })
        this.userlist = list
      })
    },
    changevalue (item) {
      this.type = ''
      this.eventtype = ''
      this.ordertype = ''
    },
    getOnlineUser () {
      const url = '/pipe-network/task_travel_trajectory/pc/num'
      this.$http
        .get(url)
        .then((resolve) => {
          console.log(resolve.data, '数据数数jjjjj')
          console.log(JSON.stringify(resolve))
          const onlineuser = []
          if (parseInt(resolve.data.num) > 0) {
            this.onlinelist = resolve.data.list
            this.onlinelist.map((item) => {
              console.log(JSON.stringify(item))
              if ((item.pointX !== null) & (item.pointY !== null)) {
                this.addSimplePoint('user', item.username, item.pointX, item.pointY)
                onlineuser.push(item)
              }
            })
            this.isshowonline = true
            this.onlinenum = resolve.data.num
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getevents () {
      const url = '/pipe-network/tenant_events/app/list'
      // let data = {sysType:"巡检"}
      console.log(JSON.stringify(this.eventquery))
      this.$http({
        url: url,
        params: this.eventquery
      })
        .then((resolve) => {
          // console.log(JSON.stringify(resolve));
          if (resolve.data.length > 0) {
            const coordinatelist = []
            this.removeLayer('事件')
            this.eventslist = resolve.data
            this.eventslist.map((item) => {
              if (item.locationInformation !== null) {
                coordinatelist.push(item)
                let coordinate
                if (typeof item.locationInformation === 'string') {
                  coordinate = item.locationInformation.split(',')
                } else {
                  coordinate = item.locationInformation
                }
                // console.log(JSON.stringify(coordinate));
                this.addSimplePoint('events', item.id, coordinate[0], coordinate[1])
              }
              this.eventsnum = coordinatelist.length
            })
            this.isshowevents = true
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getorders () {
      const url = '/pipe-network/work_order_managements/app/list'
      console.log(JSON.stringify(this.orderquery))
      this.$http
        .get(url, { params: this.orderquery })
        .then((resolve) => {
          if (resolve.data.length > 0) {
            this.removeLayer('工单')
            this.orderlist = resolve.data
            this.isshoworders = true
            const havecoordinate = []
            this.orderlist.map((item) => {
              if (item.place !== null) {
                const coordinate = item.place.split(',')
                this.addSimplePoint('order', item.id, coordinate[0], coordinate[1])
                havecoordinate.push(item)
              }
              this.ordernum = havecoordinate.length
            })
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    operation (type) {
      switch (type) {
        case 'user':
          this.useractive = !this.useractive
          if (this.isshowonline) {
            this.removeLayer('用户')
          } else {
            this.getOnlineUser()
          }
          break
        case 'events':
          this.eventactive = !this.eventactive
          if (this.isshowevents) {
            this.removeLayer('事件')
          } else {
            this.getevents()
          }
          break
        case 'order':
          this.orderactive = !this.orderactive
          if (this.isshoworders) {
            this.removeLayer('工单')
          } else {
            this.getorders()
          }
          break
      }
    },
    gettreeData () {
      this.$http.get('zone-metering/zone-metering').then(({ data }) => {
        this.treeData = data
      })
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    handleChange (value) {
      // this.pepole = value principalName
    },
    handleChang (value) {
      console.log(value)
    },
    gettype (value) {
      this.type = value
      console.log(this.type)
    },
    geteventtype (value) {
      this.eventtype = value
      console.log(this.eventtype)
    },
    getordertype (value) {
      this.ordertype = value
    },
    // 添加geojson
    addGeojson (geojsonObject) {
      var vectorSource = new VectorSource({
        features: new GeoJSON().readFeatures(geojsonObject)
      })
      var vectorLayer = new VectorLayer({
        source: vectorSource
      })
      this.map.addLayer(vectorLayer)
    },
    // 输入改变
    handleInputChange (value) {
      this.$http
        .get('/pipe-network/task_travel_trajectory/travel/page/', {
          params: {
            taskId: value.taskId
          }
        })
        .then((res) => {
          if (value.taskId !== undefined) {
            this.removeLayer('轨迹')
            this.pathlist = []
            res.data.list.map((item) => {
              this.pathlist.push({
                createUserId: item.createUserId,
                taskType: item.name,
                taskId: item.id,
                createTime: item.createTime
              })
            })
            this.name = res.data.list[0].name
            this.starttime = res.data.list[0].startTime
            this.endtime = res.data.list[0].endTime
            this.round = res.data.list[0].distance + '千米 '
            this.counttime = res.data.list[0].duration
            var param = { createUserId: res.data.list[0].createUserId, taskId: res.data.list[0].taskId }
            this.changepath(param)
          }
        })
    },
    handleInputChanges () { },
    searchinfo () {
      this.removeAllDraw()
      if (this.querytype == '') {
        this.$message.error('请选择查询类型')
      } else {
        switch (this.querytype) {
          case '1':
            this.searchpath()
            console.log(this.querytype)
            break
          case '2':
            this.eventquery = {
              sysType: '巡检',
              eventType: this.eventtype.key,
              reportPerson: this.reportPerson,
              createTime: this.date,
              eventNo: this.eventNo,
              zoneId: this.addOrUpdateForm.zoneId
            }
            this.getevents()
            break
          case '3':
            this.orderquery = {
              sysType: '巡检',
              workOrderType: this.ordertype.key,
              principalName: this.pepole,
              createTime: this.date,
              workNo: this.eventNo,
              zoneId: this.addOrUpdateForm.zoneId
            }
            this.getorders()
            break
        }
      }
    },
    searchpath () {
      // if ((this.type == '') & (this.pepole == '') & (this.pepole == '') & (this.date == '')) {
      //   this.$message.error('请选择或输入查询条件')
      // } else {
      var senddata = {
        sysType: '巡检',
        principalName: this.pepole,
        taskType: this.type.key,
        zoneId: this.addOrUpdateForm.zoneId,
        createTime: this.date,
        taskNumber: this.eventNo,
        status: 3,
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      console.log(JSON.stringify(senddata))
      this.pathlist = []
      this.$http({
        url: this.queryUrl,
        params: senddata
      }).then(({ data }) => {
        this.pagination.total = data.total
        if (data.total == 0) {
          this.$message.error('没有轨迹')
          this.isshowpathlist = false
          return
        }
        data.list.map((item) => {
          this.pathlist.push({
            createUserId: item.createUserId,
            taskType: item.taskNumber,
            taskId: item.id,
            createTime: item.createTime
          })
        })
        this.isshowpathlist = true
      })
      // }
    },
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.searchpath()
    },
    changepath (param) {
      var path = []
      this.getuserpath(param, (data) => {
        if (data.list.length == 0) {

        } else {
          data.list.map((item) => {
            console.log(JSON.stringify(item))
            var geojson = JSON.parse(item.geoJson)
            path.push({
              point: geojson.coordinates,
              start: data.list[i].startTime,
              end: data.list[i].endTime,
              name: data.list[i].name
            })
          })
          path.map((item) => {
            console.log(JSON.stringify(item))
            this.drawLineString(item)
          })
        }
      })
    },
    getuserpath (param, callback) {
      this.$http({
        url: '/pipe-network/task_travel_trajectory/page',
        params: param
      }).then(({ data }) => {
        callback(data)
      })
    },
    onChange (date, dateString) {
      this.date = dateString
    },
    // 初始化地图
    initMap () {
      const gcj02Extent = [-20037508.342789244, -20037508.342789244, 20037508.342789244, 20037508.342789244]
      const gcjMecator = new olProj.Projection({
        code: 'GCJ-02',
        extent: gcj02Extent,
        units: 'm'
      })
      olProj.addProjection(gcjMecator)
      olProj.addCoordinateTransforms('EPSG:4326', gcjMecator, window.projzh.ll2gmerc, window.projzh.gmerc2ll)
      olProj.addCoordinateTransforms('EPSG:3857', gcjMecator, window.projzh.smerc2gmerc, window.projzh.gmerc2smerc)
      // var projection = getProjection('EPSG:4326')
      this.mapcenter = this.currentUser.tenant.point
      this.map = new Map({
        view: new View({
          center: this.mapcenter, // 中心点, 填的是经纬度
          projection: 'EPSG:4326', // EPSG:4326格式的经纬度
          zoom: 14, // 地图默认缩放级别
          maxZoom: 19, // 地图最大缩放级别
          minZoom: 1 // 地图最小缩放级别
        }),
        target: 'map', // 地图容器id
        controls: defaultControls({
          zoom: false,
          rotate: false,
          attribution: false
        })
      })
      var roadLayer = new TileLayer({
        title: '高德地图',
        source: new XYZ({
          projection: gcjMecator,
          url: 'http://wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}'
        })
      })
      var scanler = new Scanler()
      this.map.addLayer(roadLayer)
      this.map.addControl(scanler)
      this.getOnlineUser()
      this.getorders()
      this.getevents()
      this.map.on('click', (e) => {
        console.log('click=====PollingMap')
        this.map.forEachFeatureAtPixel(e.pixel, (feature) => {
          this.pointType = feature.get('remark')
          let url
          switch (feature.get('remark')) {
            case 'events':
              url = `/pipe-network/tenant_events/${feature.get('name')}`
              this.$http.get(url).then((resolve) => {
                this.currentInfo = resolve.data
                this.showpopup = true
              })
              break
            case 'order':
              url = `/pipe-network/work_order_managements/${feature.get('name')}`
              this.$http.get(url).then((resolve) => {
                this.currentInfo = resolve.data
                this.showpopup = true
              })
              break
          }
        })
      })
    },
    // 开启、关闭交互
    addInteraction (type) {
      if (this.draw) {
        this.map.removeInteraction(this.draw)
      }
      var source = new VectorSource()
      var vectorLayer = new VectorLayer({
        source: source,
        style: new Style({
          fill: new Fill({
            // 填充样式
            color: 'rgba(255, 255, 255, 0.2'
          }),
          stroke: new Stroke({
            // 线样式
            color: '#00c033',
            width: 2
          }),
          image: new Circle({
            // 点样式
            radius: 7,
            fill: new Fill({
              color: '#00c033'
            })
          })
        })
      })
      this.map.addLayer(vectorLayer)
      this.draw = new Draw({
        source: source,
        type: type // 几何图形类型
        // geometryFunction: geometryFunction             //几何信息变更时的回调函数
      })
      this.map.addInteraction(this.draw)
    },
    // 清除全部
    removeAllDraw () {
      this.map.getLayers().array_.forEach((item) => {
        item.getSource().clear()
      })
    },
    closepopup () {
      this.showinfo = false
      this.showpopup = false
    },
    deleteOne () {
      var length = this.map.getLayers().array_.length
      var allFeatures = this.map.getLayers().array_[length - 1].getSource().getFeatures()
      var featureLength = allFeatures.length
      if (featureLength === 0) {
        this.map.removeInteraction(this.draw)
        this.map.removeLayer(this.map.getLayers().array_[length - 1])
        length = this.map.getLayers().array_.length
        allFeatures = this.map.getLayers().array_[length - 1].getSource().getFeatures()
        featureLength = allFeatures.length
      }
      var newFeature = allFeatures[featureLength - 1]
      this.map.getLayers().array_[length - 1].getSource().removeFeature(newFeature)
    },
    addSimplePoint (type, name, x, y) {
      const point = new Point([x, y])
      const feature = new Feature({
        geometry: point,
        name: name,
        remark: type
      })
      const vectorSource = new VectorSource()
      let vectorLayer
      vectorSource.addFeature(feature)
      switch (type) {
        case 'user':
          vectorLayer = new VectorLayer({
            title: '用户',
            source: vectorSource,
            style: this.stylefunctionUser
          })
          break
        case 'events':
          vectorLayer = new VectorLayer({
            title: '事件',
            source: vectorSource,
            style: this.stylefunctionEvents
          })
          break
        case 'order':
          vectorLayer = new VectorLayer({
            title: '工单',
            source: vectorSource,
            style: this.stylefunctionOrder
          })
          break
      }
      this.map.addLayer(vectorLayer)
    },
    stylefunctionUser (feature) {
      const name = feature.get('name')
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.online
        }),
        text: new Text({
          text: name,
          font: '22px Calibri,sans-serif',
          textAlign: 'center',
          offsetX: 0,
          offsetY: 30,
          fill: new Fill({
            color: '#87481f'
          })
        })
      })
    },
    stylefunctionEvents (feature) {
      const name = feature.get('name')
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.shijian
        })
        // text:new Text({
        //     text:name,
        //     font:'16px Calibri,sans-serif',
        //     textAlign:"center",
        //     offsetX:0,
        //     offsetY:30,
        //     fill: new Fill({
        //         color: '#87481f'
        //     })
        // })
      })
    },
    stylefunctionOrder (feature) {
      const name = feature.get('name')
      return new Style({
        fill: new Fill({
          // 填充样式
          color: 'rgba(255, 255, 255,0.2)'
        }),
        stroke: new Stroke({
          // 线样式
          color: '#00c033',
          width: 2
        }),
        image: new Icon({
          src: this.gongdan
        })
        // text:new Text({
        //     text:name,
        //     font:'16px Calibri,sans-serif',
        //     textAlign:"center",
        //     offsetX:0,
        //     offsetY:30,
        //     fill: new Fill({
        //         color: '#87481f'
        //     })
        // })
      })
    },
    setsearch () {
      if (this.showsection == false) {
        this.showsection = true
        this.isshoworders = true
        this.isshowevents = true
        this.removeAllDraw()
        console.log('23456')
      } else {
        this.showsection = false
        this.isshowpathlist = false
        this.eventquery = { sysType: '巡检' }
        this.orderquery = { sysType: '巡检' }
        this.getevents()
        this.getorders()
      }
    },
    settype () {
      const params = {
        dictCode: 'TASK_TYPE'
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        for (const i in data) {
          this.dictlist.push(data[i].dictName)
          console.log(this.dictlist)
        }
      })
    },
    getpath () {
      var senddata = { principal: this.currentUser.createUserId }
      this.$http({
        url: '/pipe-network/inspection_tasks/page',
        params: senddata
      }).then(({ data }) => {
        if (data.total == 0) {
          this.$message.error('当前用户没有轨迹')
          return
        }
        data.list.map((item) => {
          const params = {
            createUserId: senddata.principal,
            taskId: item.id
          }
          const header = {
            'Content-Type': 'application/json',
            Authorization: this.token
          }
          this.$http({
            url: '/pipe-network/task_travel_trajectory/page',
            method: 'get',
            params: params,
            header: header
          }).then(({ data }) => {
            // console.log(JSON.stringify(data))
            var path = []
            for (const i in data.list) {
              var point = JSON.parse(data.list[i].geoJson).coordinates
              path.push({
                point: point,
                start: data.list[i].startTime,
                end: data.list[i].endTime,
                name: data.list[i].name
              })
            }
            for (const i in path) {
              this.drawLineString(path[i])
            }
          })
        })
      })
    },
    showlayer () {
      if (this.isshow) {
        this.isshow = false
        this.eventactive = true
        this.useractive = true
        this.orderactive = true
      } else {
        this.isshow = true
        this.isshowPathlist = false
      }
    },
    // 轨迹回放
    drawLineString (coord) {
      console.log(coord, '数据！')
      this.positions = coord.point
      var starttime = new Date(coord.start)
      starttime = starttime.getTime()
      var endtime = new Date(coord.end)
      endtime = endtime.getTime()
      var fllow = (endtime - starttime) / 1000 / 60 / 60
      fllow = fllow + '小时'
      var from = turf.point(this.positions[0])
      var to = turf.point(this.positions[this.positions.length - 1])
      var options = { units: 'miles' }
      var distance = turf.distance(from, to, options)
      distance = Math.ceil(distance) + '千米 '
      this.showinfo = true
      if (this.positions.length <= 0) return
      styles = {
        route: new Style({
          stroke: new Stroke({
            width: 5,
            color: '#694d9f'
          })
        }),
        icon: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: start
          })
        }),
        move: new Style({
          image: new Circle({
            // 点样式
            radius: 8,
            fill: new Fill({
              color: '#6b473c'
            }),
            stroke: new Stroke({
              color: '#fffffb',
              width: 3
            })
          })
        }),
        geoMarker: new Style({
          image: new Icon({
            anchor: [0.5, 1],
            // offset:[30,10],
            src: end
          })
        })
      }
      lineMarker = new Feature({
        type: 'route',
        geometry: new LineString(this.positions),
        population: 4000,
        rainfall: 500
      })
      var startMarker = new Feature({
        type: 'icon',
        geometry: new Point(this.positions[0]),
        population: 4000,
        rainfall: 500
      })
      var endMarker = new Feature({
        type: 'geoMarker',
        geometry: new Point(this.positions[this.positions.length - 1]),
        population: 4000,
        rainfall: 500
      })
      position = startMarker.getGeometry().clone()
      this.geoMarker = new Feature({
        type: 'move',
        geometry: position,
        population: 4000,
        rainfall: 500,
        anchor: [0.5, 0.8]
      })
      var source = new VectorSource({
        type: 'LineString',
        features: [lineMarker, this.geoMarker, startMarker, endMarker]
      })
      lineLayer = new VectorLayer({
        title: '轨迹',
        source: source,
        style: function (feature) {
          return styles[feature.get('type')]
        }
      })
      this.map.getView().setCenter(this.positions[0])
      // this.map.getView().setZoom(19)
      this.map.addLayer(lineLayer)
      // this.traversed = 0
      // this.speed = 1
      // this.currentCount = 0
      this.startAnimation()
      this.isshowpath = true
    },
    // 移动轨迹
    moveFeature (event) {
      if (this.animating) {
        const time = event.frameState.time
        const elapsedTime = time - this.startTime
        this.distance = (this.distance + (this.speed * elapsedTime) / 1e4) % 2
        this.startTime = time
        const currentCoordinate = lineMarker
          .getGeometry()
          .getCoordinateAt(this.distance > 1 ? 2 - this.distance : this.distance)
        var from = turf.point(currentCoordinate)
        var to = turf.point(this.positions[this.positions.length - 1])
        var options = { units: 'kilometers' }
        var pointDistance = turf.distance(from, to, options)
        if (pointDistance <= 0.005) {
          this.stopAnimation()
        }
        position.setCoordinates(currentCoordinate)
        const vectorContext = getVectorContext(event)
        vectorContext.setStyle(styles.move)
        vectorContext.drawGeometry(position)
        this.map.render()
      }
    },

    startAnimation () {
      this.startTime = Date.now()
      lineLayer.on('postrender', this.moveFeature)
      this.geoMarker.setGeometry(null)
    },

    stopAnimation (ended) {
      this.animating = true
      var coord = ended ? this.positions[this.positions.length - 1] : this.positions[0]
      this.geoMarker.setGeometry(coord)
      lineLayer.un('postrender', this.moveFeature)
    },

    // 找点位
    searchPoint () {
      searchPlace(this.tagInputValue).then((res) => {
        // debugger
        // console.log('workplace -> call getRoleList()', res)
        if (res.pois.length > 0) {
          var findPointXY = res.pois[0].entr_location
          findPointXY = findPointXY.split(',')
          findPointXY[0] = Number(findPointXY[0])
          findPointXY[1] = Number(findPointXY[1])
        }
        this.addSimplePoint(findPointXY[0], findPointXY[1])
        this.map.getView().setCenter(findPointXY)
      })
    },

    // 移除图层
    removeLayer (layer) {
      var allLayer = this.map.getLayers().array_
      var layers = []
      allLayer.forEach((item) => {
        if (item.values_.title == layer) {
          layers.push(item)
        }
      })
      layers.map((item) => {
        this.map.removeLayer(item)
      })
      // this.map.getView().setZoom(14);
      switch (layer) {
        case '轨迹':
          this.isshowpath = false
          this.showinfo = false
          this.name = ''
          this.starttime = ''
          this.endtime = ''
          this.round = ''
          this.counttime = ''
          this.distance = 0
          break
        case '用户':
          this.isshowonline = false
          break
        case '事件':
          this.isshowevents = false
          break
        case '工单':
          this.isshoworders = false
          break
      }
    }
  }
}
</script>

<style lang="less" scoped>
.Track {
  width: 250px;
  height: 400px;
  position: absolute;
  bottom: 1em;
  right: 10px;
  background: rgba(0, 32, 54, 0.75);
  z-index: 3;
  border-radius: 10px;
}

.app {
  position: relative;
}

.map {
  width: 100%;
  height: 695px;
  border: 4px solid #ffffff;
  border-radius: 4px;
}

.righticon {
  float: right;
  width: 15px !important;
  height: 15px !important;
  margin: 15px 0px 0px 10px;
}

/deep/#section p {
  color: #fff;
}

/deep/.ant-table-thead>tr:first-child>th:last-child {
  background: rgba(63, 87, 101, 1);
  color: #fff;
}

/deep/.ant-table-tbody>tr>td {
  padding: 16px 16px;
  overflow-wrap: break-word;
  color: #ffff;
}

/deep/.ant-table-placeholder {
  background: rgba(63, 87, 101, 1);
  color: #fff;
}

/deep/.ant-select-selection--single {
  background: rgba(0, 32, 54, 0.75);
  color: #fff;
}

/deep/.ant-calendar-picker-input.ant-input {
  background: rgba(0, 32, 54, 0.75);
  color: #fff;
}

/deep/.ant-table-column-title {
  color: #fff;
}

// #section p[data-v-1c716fc2] ,#title[data-v-1c716fc2]{
//   color: #fff;
// }
#control {
  width: auto;
  height: 40px;
  position: absolute;
  bottom: 1em;
  right: 19.5em;
  background: rgba(0, 32, 54, 0.75);
  z-index: 3;
  color: white;
  line-height: 35px;
}

#control img {
  width: 25px;
  height: 30px;
  margin-left: 10px;
}

#control span {
  margin-left: 4px;
  font-size: 16px;
}

#tuli {
  width: auto;
  height: auto;
  background: rgba(0, 32, 54, 0.75);
  z-index: 3;
  position: absolute;
  bottom: 20px;
  right: 5px;
  display: flex;
  border-radius: 10px;
  flex-direction: column;
  justify-content: center;
  color: white;

  #Legend {
    width: 100%;
    height: 40px;
    line-height: 40px;
    margin-left: 0px;
    // margin-bottom: 20px;
    padding-left: 10px;
    background-image: linear-gradient(270deg, rgba(8, 144, 242, 0.5) 0%, #0890f2 100%);
  }
}

#tuli div {
  margin: 0px 10px 0px 10px;
  height: 45px;
  line-height: 45px;
}

#tuli:first-child {
  margin-top: 20px;
}

#tuli div img {
  width: 30px;
  height: 30px;
}

#tuli div span {
  margin-left: 6px;
  font-size: 16px;
}

#section {
  z-index: 0;
  background: rgba(0, 32, 54, 0.75);
  position: absolute;
  left: 0px;
  bottom: 0px;
}

#header {
  font-size: 18px;
  line-height: 50px;
  width: 100%;
  border-bottom: 1px solid #3333;
}

#header img {
  width: 20px;
  height: 20px;
  float: right;
  margin-right: 10px;
  margin-top: 15px;
}

#section p {
  font-size: 16px;
  margin-left: 10px;
  line-height: 40px;
}

#title {
  margin-left: 10px;
  color: #fff;
}

#button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 30px;
}

#clearpath {
  width: 100px;
  margin: 0 auto;
  line-height: 35px;
  text-align: center;
  border: 1px solid #3333;
  margin-top: 20px;
}

#popup,
#popuplist {
  width: 250px;
  height: auto;
  line-height: 30px;
  z-index: 9;
  position: absolute;
  top: 1em;
  right: 1em;
  background: rgba(0, 32, 54, 0.75);
  color: white;
  text-align: left;
  border-radius: 10px;
}

#popup ul,
#popuplist ul {
  margin-left: -20px;
}

#popup ul span,
#popuplist ul span {
  margin-left: 10px;
}

#closeitem {
  height: 40px;
  width: 100%;
  color: #fff;
  background: rgb(16 133 217);
}

#closeitem span {
  line-height: 10px;
  margin-left: 10px;
  font-size: 16px;
  line-height: 40px;
}

#close {
  float: right;
  width: 20px;
  height: 20px;
  margin: 10px 10px 10px 10px;
}

#desript {
  word-wrap: break-word;
  margin-right: 10px;
}

.active {
  color: #50c2d1;
}
</style>
